<template>
    <div >
        <button class="btn icon-btn pr-0 mx-1"
                name="add user to shop"
                data-toggle="tooltip"
                :disabled="$isNotAllowed($TYPES.ACTIONS.UPDATE)"
                data-placement="top"
                :title="$t('UI.assignUser')"
                @click.stop="$emit('addUserToShop', shop)"
                v-if="$isAllowed($TYPES.ACTIONS.UPDATE) && !hideAddition">
            <i class="icon icon-cph_iconset_plus"></i>
        </button>
        <button class="btn icon-btn pr-0 mx-1"
                name="Edit shop"
                data-toggle="tooltip"
                :disabled="$isNotAllowed($TYPES.ACTIONS.UPDATE)"
                data-placement="top"
                :title="$t('UI.edit')"
                v-if="$isAllowed($TYPES.ACTIONS.UPDATE) && !hideAddition"
                @click.stop="$emit('editShop', shop)"
                >
            <i class="icon icon-cph_iconset_edit"></i>
        </button>
        <button class="btn icon-btn pr-0 mx-1"
                name="delete shop"
                :disabled="$isNotAllowed($TYPES.ACTIONS.REMOVE)"
                data-toggle="tooltip"
                data-placement="top"
                :title="userTableView
                    ? $t('UI.detatchShop')
                    : $t('COMPANYDATA.removeShop')"
                v-if="$isAllowed($TYPES.ACTIONS.REMOVE)"
                @click.stop="userTableView
                ? $emit('removeShopFromUser', shop.id)
                : confirmAction({
                    question: $t('COMPANYDATA.removeShop'),
                    data: shop,
                    callback: deleteShop
                })"
                >
            <i class="icon icon-cph_iconset_trash_can"></i>
        </button>
        <button class="btn icon-btn pr-0 mx-1"
                @click="$emit('open', shop)"
                name="show assigned users"
                :disabled="!hideAddition
                            && !shop.users
                            || shop.users
                            && (shop.users.length === 0)"
                data-toggle="tooltip" data-placement="top"
                title="Show assigned users">
            <i class="icon icon-cph_iconset_user"></i>
        </button>
        <button class="btn icon-btn pr-0 mx-1"
                @click.stop="generateQr"
                data-toggle="tooltip" data-placement="top" title="Generate qr"
                name="get qr" v-if="showQrGenerateIconFlag">
            <div class="icon">
                <img  src="/static/icons/0249-qrcode.svg" alt="qrCode icon">
            </div>
        </button>
    </div>
</template>

<script>
    import {RegistrationPerimeter} from '../../../router/perimeters/registrationPerimeter';
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    export default {
        name: 'welcome-table-buttons',
        data () {
            return {
                showQrGenerateIconFlag: false
            };
        },
        props: {
            shop: {},
            index: {
                type: Number
            },
            userTableView: {
                type: Boolean
            },
            hideAddition: {
                type: Boolean
            },
        },
        computed: {
            ...mapGetters({user : 'getUser'})
        },
        perimeters: [RegistrationPerimeter],
        methods: {
            ...mapMutations(['updateUserShopList']),
            ...mapActions([
                'confirmAction',
                'DelShop',
                'DelShopFromUser',
                'GetShopFromUser'
            ]),
            async deleteShop (shop) {
                if(shop.users) {
                    await this.$utils.resolvePromises(
                        shop.users.map(({id}) => 
                            this.DelShopFromUser({id, shopId: shop.id})
                    ));
                }
                await this.DelShop(shop);
                let {data: shops} = await this.GetShopFromUser({id: this.user.id});
                this.updateUserShopList(shops);
            },
            generateQr () {
                const canvas = document.createElement('canvas');
                canvas.width = 1000;
                canvas.height = 1000;

                QRCode.toCanvas(canvas, `shop-${this.shop.id}`, {
                    errorCorrectionLevel: 'H',
                    version: 10
                }, (error) => {
                    if (error)  {
                        console.error(error);
                    } else {
                        let ctx = canvas.getContext('2d');
                        ctx.font = '12px serif';
                        ctx.strokeText('scan this qr code for initial setup', 25, 12);
                        ctx.strokeText(this.shop.name, 25, 255);
                        let url = canvas.toDataURL();
                        let downloadAnchorNode = document.createElement('a');
                        downloadAnchorNode.setAttribute('href', url);
                        downloadAnchorNode.setAttribute('download', `${this.$utils.shortid.generate()}.png`);
                        downloadAnchorNode.click();
                        downloadAnchorNode.remove();
                    }
                });
            },
            async showQrGenerateIcon () {
                try {
                    await this.GetSetupManagerDataById(`shop-${this.shop.id}`);
                    this.showQrGenerateIconFlag = true;
                } catch (err) {
                    console.error(err);
                }
            }
        }
    }
</script>